import { useEffect } from "react";
import { siteUrl } from "../data";

const OG_IMAGE =
  "https://images.unsplash.com/photo-1606059979642-8390434af3d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxkcml2aW5nJTIwc2NlbmljJTIwcm9hZHxlbnwwfHx8fDE3ODcyODY2Nzh8MA&ixlib=rb-4.1.0&q=85";

function upsert(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    el.setAttribute("data-bc-seo", "1");
    document.head.appendChild(el);
  }
  return el;
}

export default function SEO({ lang, title, description, pathEn, pathIt, jsonLd }) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    const path = lang === "it" ? pathIt : pathEn;
    const canonical = siteUrl(path);

    upsert('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.name = "description";
      return m;
    }).content = description;

    upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.rel = "canonical";
      return l;
    }).href = canonical;

    const og = {
      "og:title": title,
      "og:description": description,
      "og:url": canonical,
      "og:type": "website",
      "og:site_name": "BoingCars",
      "og:image": OG_IMAGE,
      "og:locale": lang === "it" ? "it_IT" : "en_GB",
      "twitter:card": "summary_large_image",
      "twitter:title": title,
      "twitter:description": description,
    };
    Object.entries(og).forEach(([prop, content]) => {
      const isName = prop.startsWith("twitter:");
      const sel = isName ? `meta[name="${prop}"]` : `meta[property="${prop}"]`;
      upsert(sel, () => {
        const m = document.createElement("meta");
        if (isName) m.name = prop;
        else m.setAttribute("property", prop);
        return m;
      }).content = content;
    });

    [
      ["en", siteUrl(pathEn)],
      ["it", siteUrl(pathIt)],
      ["x-default", siteUrl(pathEn)],
    ].forEach(([hl, href]) => {
      upsert(`link[hreflang="${hl}"]`, () => {
        const l = document.createElement("link");
        l.rel = "alternate";
        l.setAttribute("hreflang", hl);
        return l;
      }).href = href;
    });

    if (jsonLd) {
      upsert('script[data-bc-ld="1"]', () => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-bc-ld", "1");
        return s;
      }).textContent = JSON.stringify(jsonLd);
    }
  }, [lang, title, description, pathEn, pathIt, jsonLd]);

  return null;
}
